import { render, staticRenderFns } from "./updateOrCreateAutomations.vue?vue&type=template&id=0525fefe"
import script from "./updateOrCreateAutomations.vue?vue&type=script&lang=js"
export * from "./updateOrCreateAutomations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports